module.exports = __webpack_public_path__ + "img/optum-logo.34a3c5b4.svg";